export default class OrganizationName {}

OrganizationName.Fetch = 'Fetch';
OrganizationName.PetMeds = 'PetMeds';
